import RightArrow from '../../image/right-arrow.png';
import React from 'react';
import { 
    NewsTitle,
    Newsmonth,
    ReadMoreButton,
    Circle,
    Arrow,
    Wrapper,
    CardBox,
    Child,
    Description,
    Image
} from './style';
import { Box } from 'reflexbox';

export const NewsCardComponent = ({
    title,
    description,
    created_at, // Format: "2024-02-14T15:04:05Z"
    bg, 
    path
}) => {

    const sliceString = (str, size) => {
        if (str.length > size) {
            return str.slice(0, size) + '...';
        }
        return str;
    }

    const getMonthAndYear = (date) => {
        const dateObj = new Date(date);
        const monthName = dateObj.toLocaleString('en-US', { month: 'long' });
        const year = dateObj.getFullYear();
        
        return `${monthName} ${year}`;
    }

    return (
        <Wrapper>
            <Child>
                <Box width="100%" height="20%">
                    <Image 
                        src={"https://cms.sequoiaadvocates.com/storage/" + bg} 
                        alt="" 
                    />
                </Box>
                <CardBox>
                    <NewsTitle>
                        {sliceString(title, 20)}
                    </NewsTitle>
                    <Newsmonth>
                        {getMonthAndYear(created_at)}
                    </Newsmonth>
                    <Description>
                        {sliceString(description, 100)}
                    </Description>
                    <ReadMoreButton
                        onClick={() => {
                            window.open(path, '_blank');
                        }}
                    >
                        READ MORE
                        <Circle> 
                            <Arrow src={RightArrow} />
                        </Circle>
                    </ReadMoreButton>
                </CardBox>
            </Child>
        </Wrapper>
    )
}